// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1BQOW","requiredAsterisk":"Info_requiredAsterisk__355HW"};